// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import 'view-design/dist/styles/iview.css'
import './assets/font/font.css'

// 空值判断
import blankValid from './common/blank-valid.js'
Vue.prototype.$blankValid = blankValid

// 防止dialog导致页面滚动条消失抖动
ElementUI.Dialog.props.lockScroll.default = false
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js